import { Toast as showToast } from "core/components/global/toast/toast";
import { getCsrfTokenFromCookie } from "core/utils/csrf";
import axios from "axios";
import { ApiKey, Group, User } from "../components/admin/admin.type";
import { Report } from "../components/admin/admin.type";
import { fetchBaseUrl } from "core/utils/common";


const baseURL = fetchBaseUrl({port: 8083});

/////////////////////////////////////////
// the ragdad component
/////////////////////////////////////////
// Handle file upload
export async function fileUploadSubmittal(amsAccessToken: string, formData: FormData) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await fetch(`${baseURL}/api/upload`, {
      method: 'POST',
      headers: {
        Authorization: amsAccessToken,
        'X-CSRF-Token': csrfToken,
      },
      body: formData,
    });

    const data = await response.json();

    if (data.message) {
      return(data.message);
    } else {
      return(null);
    }
  } catch (error: any) {
    return(null);
  }
}

// Handle document creation
export async function createDocumentSubmittal(amsAccessToken: string, data: {"embedModel": string, "collectionName": string, "text": string}) {
    try {
        let inputData

        if( data.embedModel !== "" ) {
        inputData = {
            collectionName: data.collectionName,
            text: data.text,
            citations: [{ embed_model: data.embedModel }],
        };
        }
        else {
        inputData = {
            collectionName: data.collectionName,
            text: data.text,
            citations: [{}],
        };
        }

        const csrfToken = getCsrfTokenFromCookie();
        const response = await fetch(`${baseURL}/api/create_document`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': amsAccessToken,
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(inputData),
        });
        
        const responseData = await response.json()
        return(responseData.message);
    } catch (error) {
        return(null);
    }
}

// Search for an index
export async function searchDocumentsSubmittal(amsAccessToken: string,  data: {"collectionName": string, "searchString": string, "embedModel": string}) {
    try {
        const csrfToken = getCsrfTokenFromCookie();
        const response = await fetch(`${baseURL}/api/search`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': amsAccessToken,
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(data),
        })

        const responseData = await response.json()
        return(responseData.message);
    } catch (error) {
        return(null);
    }
}

// Delete methods

// Delete a user
export async function deleteUser(userId) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "DELETE",
      url: `${baseURL}/admin/users/${userId}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken,
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

// Delete a group
export async function deleteGroup(groupId) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "DELETE",
      url: `${baseURL}/admin/groups/${groupId}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken,
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

// Delete a provider
export async function deleteProvider(providerId) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "DELETE",
      url: `${baseURL}/admin/providers/${providerId}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

// Delete an API key
export async function deleteApiKey(apiKeyId) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "DELETE",
      url: `${baseURL}/admin/apikey/${apiKeyId}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

// Delete a report
export async function deleteReport(reportId) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "DELETE",
      url: `${baseURL}/admin/reports/${reportId}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    });
    return response.data;
  } catch (error) {
    return null;
  }
}

// Delete a report
export async function deleteInvite(inviteId) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "DELETE",
      url: `${baseURL}/admin/invites/${inviteId}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    });
    return response.data;
  } catch (error) {
    return null;
  }
}


// Delete an Index
export async function deleteIndexSubmittal(amsAccessToken: string, indexName: String) {
    try {
        const csrfToken = getCsrfTokenFromCookie();
        const response = await fetch(`${baseURL}/api/delete_index`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': amsAccessToken,
                'X-CSRF-Token': csrfToken
            },
            body: JSON.stringify({ indexName: indexName }),
        })

        const responseData = await response.json()
        return(responseData);
    } catch (error) {
        return(null);
    }
}

// Fetch all indicies
export async function getAllIndicesSubmittal(amsAccessToken: string) {
    try {
        const response = await fetch(`${baseURL}/api/all_indices`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': amsAccessToken
            }
        })

        const responseData = await response.json();
        return(responseData);
    } catch (error) {
        return(null);
    }
}

//////////////////////////////////////
// adminUsers.tsx
//////////////////////////////////////
// Update the user 
export async function updateUser(user: User) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/users/update`,
      withCredentials: true,
      headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(user),
    })
    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    return(null);
  }
}

//////////////////////////////////////
// adminGroups.tsx
//////////////////////////////////////
// Create a Group
export async function createGroup(group: Group) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/groups/create`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(group)
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    return(null);
  }
}

// Update a Group
export async function updateGroup(group: Group) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/groups/update`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(group)
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    return(null);
  }
}

//////////////////////////////////////
// adminReports.tsx
//////////////////////////////////////
// Create report
export async function createReport(formData) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/reports/create`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(formData)
    })
    
    return(response.data.message);
  } catch (error) {
    console.error("Error creating report:", error);
    return(null);
  }
};

// Update report
export async function updateReport(formData: Report, reportId: string) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/reports/update/${reportId}`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(formData)
    })
  
    return(response.data.message);
  } catch (error) {
    console.error("Error updating report:", error);
    return(null);
  }
};

//////////////////////////////////////
// adminApiKey.tsx
//////////////////////////////////////
// Create an API Key
export async function createApiKey(keyData: ApiKey) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/apikey`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(keyData)
    })
    
    const promiseResponse = await response.data;
  
    return(promiseResponse)
  } catch (error) {
    return(null);
  }
}

// make a get req to get the number of api keys

export async function getApiKey() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/apikey`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json"
      }
    });

    const promiseResponse = await response.data;
    return promiseResponse;
  } catch (error) {
    return null;
  }
}


//////////////////////////////////////
// adminInvite.tsx
//////////////////////////////////////
// Invite a user
export async function sendInvite(inviteData) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/emailinvite`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(inviteData)
    })
    
    if (response.status < 300) {
      const promiseResponse = await response.data;
    
      return(promiseResponse)
    } else {
      return(null);
    }
  } catch (error) {
    return(null);
  }
}

// Update an Invite
export async function updateInvite(inviteId, inviteData) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: `${baseURL}/admin/invites/update/${inviteId}`,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        'X-CSRF-Token': csrfToken
      },
      data: JSON.stringify(inviteData)
    })
    
    const promiseResponse = await response.data;
  
    return(promiseResponse)
  } catch (error) {
    return(null);
  }
}

// Resend Invite
export async function resendInvite(inviteId: string) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: 'POST',
      url: `${baseURL}/admin/invites/resend/${inviteId}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    });

    return response.data.message;
  } catch (error) {
    return(null);
  }
}


//////////////////////////////////////
// Providers for the Sidebar Redux
//////////////////////////////////////
// ETL the provider data for the Sidebar to consume

export async function getSidebarProviders(bearerToken: string) {
  const organizedData = {}

  // Function to handle an array of incoming data
  function organizeDataList(incomingDataList) {
    incomingDataList.map((incomingData) => {
      // Create a group for the org
      if (!organizedData[incomingData.options.org]) {
        organizedData[incomingData.options.org] = {
          path: ``,
          state: incomingData.options.org,
          hasParameter: false,
          children: [],
          sidebarProps: {
              displayText: incomingData.options.org,
              isDisabled: false,
              showRawText: true,
          }
        }
      }
      
      // Push the data to the group
      organizedData[incomingData.options.org].children.push({
        path: "/secai/chat/:provider",
        state: incomingData.name,
        hasParameter: true,
        children: [],
        sidebarProps: {
            displayText: incomingData.name,
            isDisabled: false,
            showRawText: true,
        }
      })
    });
  }

  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/api/provider_list`,
      headers: {
        "Content-Type": "application/json",
        "authorization": bearerToken,
      }
    });
    
    // Get the raw response data
    const responseData = await response.data;

    organizeDataList(responseData);
    return Object.values(organizedData).flat();
  } catch (error) {
    return(null);
  }
}

// Fetch all IAUs
export async function getRawProviders(bearerToken) {
  try {

    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/api/provider_list`,
      headers: {
        "Content-Type": "application/json",
        "authorization": bearerToken,
      }
    });
  
    return(response)
  } catch (error) {
    return null;
  }
}

//////////////////////////////////////
// General Data for admin pages
//////////////////////////////////////
// Fetch all reports
export async function getReports() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/reports`,
      withCredentials: true
    })
    
    const promiseResponse = await response.data;
  
    return(promiseResponse)
  } catch (error) {
    return null;
  }
}


// Fetch all the API Keys' metadatas
export async function getApiKeys() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/apikey`,
      withCredentials: true
    })
    
    const responseData = await response.data;
    return(responseData);
  } catch (error) {
    // showToast(`Unable to a fetch api keys at this time.`, "error");
    return(null);
  }
}

// Fetch all Conversations
export async function getConversations() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/conversations`,
      withCredentials: true
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    // showToast(`Unable to a fetch conversations at this time.`, "error");
    return(null);
  }
}

// Fetch all User Brackets
export async function getConversationBrackets() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/conversations/brackets`,
      withCredentials: true
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    // showToast(`Unable to a fetch conversations at this time.`, "error");
    return(null);
  }
}

// Fetch all Conversation Daily Metrics
export async function getConversationDailyStats() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/conversations/daily-stats`,
      withCredentials: true
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    // showToast(`Unable to a fetch conversations at this time.`, "error");
    return(null);
  }
}

// Fetch all Conversation By Popularity Per Day for the Month
export async function getConversationPopularity() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/conversations/daily-models`,
      withCredentials: true
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    // showToast(`Unable to a fetch conversations at this time.`, "error");
    return(null);
  }
}

// Fetch a specific user conversation
export async function getConversationsByID(userID: string) {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/user-conversations/${userID}`,
      withCredentials: true
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    // showToast(`Unable to a fetch conversations at this time.`, "error");
    return(null);
  }
}

// delete a specific user conversation
export async function deleteConversationByID(conversationID: string) {
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "DELETE",
      url: `${baseURL}/admin/conversations/${conversationID}`,
      withCredentials: true,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    })
    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    // showToast(`Unable to a fetch conversations at this time.`, "error");
    return(null);
  }
}

// Fetch all Invites
export async function getInvites() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/invites`,
      withCredentials: true
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    // showToast(`Unable to a fetch invites at this time.`, "error");
    return(null);
  }
}

// Fetch all feedback
export async function getFeedback() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/feedback`,
      withCredentials: true,
    })
    const responseData = await response.data;
    return(responseData);
  } catch (error) {
    // showToast(`Unable to a fetch feedback at this time.`, "error");
    return(null);
  }
}

// Fetch all groups
export async function getGroups() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/groups`,
      withCredentials: true
    })

    const responseData = await response.data;
    return(responseData);
  } catch (error) {
    // showToast(`Unable to a fetch groups at this time.`, "error");
    return(null);
  }
}

// Fetch all users with their groups
export async function getUsers() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/users`,
      withCredentials: true,
    })

    const responseData = await response.data;
    return(responseData)
  } catch (error) {
    return(null);
  }
}

// Fetch all providers
export async function getProviders() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/providers`,
      withCredentials: true
    })

    // const responseData = await response.data;
    let responseData = response.data;

    // remove the providers from their groupings
    const aggregatedProviders = responseData.flatMap((item) => {
      return item.providers && Array.isArray(item.providers.providers) ? item.providers.providers : [];
    });
    return(aggregatedProviders)
  } catch (error) {
    return(null);
  }
}

export async function getProvidersRaw(bearerToken: string) {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/api/provider_list`,
      headers: {
        "Content-Type": "application/json",
        authorization: bearerToken,
      },
    });
  
    if (response.status < 300) {
      // Get the raw response data
      const responseData = await response.data;
    
      return responseData;
    } else {
      return(null)
    }
  } catch (error) {
    return(null) 
  }
}

// Fetch all users
export async function getMetrics() {
  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/admin/metrics`,
      withCredentials: true
    })

    // const responseData = await response.data;
    let responseData = response.data;

    return(responseData)
  } catch (error) {
    return(null);
  }
}